import { render, staticRenderFns } from "./BookingsRightSidebar.vue?vue&type=template&id=1889df08&scoped=true&"
import script from "./BookingsRightSidebar.vue?vue&type=script&lang=ts&"
export * from "./BookingsRightSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./BookingsRightSidebar.vue?vue&type=style&index=0&id=1889df08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1889df08",
  null
  
)

export default component.exports